import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogContentText, Stack } from '@mui/material';

import { Button } from '@components/base';
import { LayoutEntityType } from '@models/Content';

export type LayoutEntityConflictSectionProps = {
  context: 'save' | 'saveCopy';
  disabled?: boolean;
  entityType: LayoutEntityType;
  handleSave: VoidFunction;
};

const LayoutEntityConflictSection: FC<LayoutEntityConflictSectionProps> = ({
  context,
  disabled,
  entityType,
  handleSave,
}) => {
  const { t } = useTranslation();

  return (
    <Stack alignItems='flex-start'>
      <DialogContentText gutterBottom>
        {t('layoutEntityConflict.description', {
          context,
          entityType: t(`contentType.${entityType}`).toLocaleLowerCase(),
        })}
      </DialogContentText>

      <Button disabled={disabled} onClick={handleSave} variant='contained'>
        {t('layoutEntityConflict.button', { context })}
      </Button>
    </Stack>
  );
};

export default LayoutEntityConflictSection;
